<section class="py-20 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white">
  <div class="container mx-auto px-4">
    <div class="text-center mb-12">
      <div class="inline-flex items-center justify-center bg-blue-500/15 text-blue-300 border border-blue-500/40 px-4 py-1 rounded-full text-sm font-semibold mb-4">
        <i class="bx bx-badge-check mr-2"></i>Transparent Pricing
      </div>
      <h1 class="text-4xl md:text-5xl font-bold text-white mb-4">
        Simple, <span class="text-blue-400">Transparent</span> Pricing
      </h1>
      <p class="text-xl text-slate-300 max-w-3xl mx-auto">
        Choose the perfect plan for your needs. All plans include enterprise-grade features and 24/7 support.
      </p>
      
      <!-- Estimate Price Button -->
      <div class="mt-8">
        <a href="/pricing-calculator" class="inline-block px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-700 text-white font-bold rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
          <i class="bx bx-calculator mr-2"></i>Estimate Price
        </a>
      </div>
    </div>

    <div class="mb-16">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div *ngFor="let plan of getFeaturedPlans()" class="relative bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200 transition-all hover:-translate-y-1">
          <div class="absolute -top-12 -right-12 w-40 h-40 rounded-full blur-3xl opacity-25 bg-gradient-to-br from-blue-500 to-indigo-600"></div>
          <div class="p-8">
            <div class="flex items-start justify-between mb-4">
              <h3 class="text-xl font-extrabold text-gray-900">{{ plan.name }}</h3>
              <span class="text-xs font-bold px-3 py-1 rounded-full bg-blue-100 text-blue-700">{{ sharedCpuBilling | titlecase }}</span>
            </div>
            <div class="flex items-center gap-4 mb-6">
              <div class="w-12 h-12 rounded-xl flex items-center justify-center text-white shadow-md bg-gradient-to-br from-blue-600 to-indigo-700">
                <i class="bx bx-chip text-2xl"></i>
              </div>
              <div class="text-3xl font-extrabold text-gray-900">
                ₹{{ getFeaturedPrice(plan) }}
                <span class="text-sm font-semibold text-gray-500 ml-1" *ngIf="sharedCpuBilling === 'hourly'">/hr</span>
                <span class="text-sm font-semibold text-gray-500 ml-1" *ngIf="sharedCpuBilling === 'monthly'">/mo</span>
                <span class="text-sm font-semibold text-gray-500 ml-1" *ngIf="sharedCpuBilling === 'yearly'">/yr</span>
              </div>
            </div>
            <ul class="space-y-2 mb-6">
              <li class="flex items-center text-gray-700 text-sm"><i class="bx bx-check-circle text-blue-600 mr-2"></i>{{ plan.vcpu }} vCPU</li>
              <li class="flex items-center text-gray-700 text-sm"><i class="bx bx-check-circle text-blue-600 mr-2"></i>{{ plan.ram }}</li>
              <li class="flex items-center text-gray-700 text-sm"><i class="bx bx-check-circle text-blue-600 mr-2"></i>{{ plan.storage }}</li>
              <li class="flex items-center text-gray-700 text-sm" *ngIf="sharedCpuBilling === 'yearly'"><i class="bx bx-check-circle text-green-600 mr-2"></i>{{ plan.discount }} discount</li>
              <li class="flex items-center text-gray-700 text-sm" *ngIf="sharedCpuOS === 'windows' && plan.minimumBilling"><i class="bx bx-error-circle text-red-600 mr-2"></i>Minimum Billing ₹{{ plan.minimumBilling }}</li>
            </ul>
            <a href="#" class="inline-flex items-center font-bold transition-all duration-200 px-5 py-2.5 rounded-xl shadow-md bg-gradient-to-r from-blue-600 to-indigo-700 text-white hover:opacity-90">
              <span>Deploy Now</span>
              <i class="bx bx-right-arrow-alt ml-2 text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Service Categories Filter -->
    <div class="mb-12">
      <div class="text-center mb-8">
        <h2 class="text-2xl md:text-3xl font-bold text-white mb-6">
          Explore Our Services
        </h2>
        
        <div class="flex flex-wrap justify-center gap-3">
          <button 
            class="px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 shadow-sm"
            [ngClass]="activeCategory === null ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-lg' : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'"
            (click)="setActiveCategory(null); $event.preventDefault()">
            All Services
          </button>
          <button 
            class="px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 shadow-sm"
            [ngClass]="activeCategory === 'compute' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-lg' : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'"
            (click)="setActiveCategory('compute'); $event.preventDefault()">
            Compute
          </button>
          <button 
            class="px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 shadow-sm"
            [ngClass]="activeCategory === 'storage' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-lg' : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'"
            (click)="setActiveCategory('storage'); $event.preventDefault()">
            Storage
          </button>
          <button 
            class="px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 shadow-sm"
            [ngClass]="activeCategory === 'databases' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-lg' : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'"
            (click)="setActiveCategory('databases'); $event.preventDefault()">
            Databases
          </button>
        </div>
      </div>
    </div>

    <!-- Shared CPU Pricing -->
    <div class="mb-12" *ngIf="isCategoryVisible('compute')">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-6">
        <div>
          <h3 class="text-2xl font-bold text-white mb-2">Shared CPU Instances</h3>
          <p class="text-slate-300">
            Cost-effective virtual machines for general-purpose workloads.
          </p>
        </div>
        
        <div class="flex flex-col sm:flex-row gap-4">
          <div class="flex bg-white rounded-lg border border-gray-300 p-1 shadow-sm">
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="sharedCpuOS === 'linux' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setSharedCpuOS('linux')">
              <i class="fab fa-linux mr-2"></i> Linux
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="sharedCpuOS === 'windows' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setSharedCpuOS('windows')">
              <i class="fab fa-windows mr-2"></i> Windows
            </button>
          </div>
          
          <div class="flex bg-white rounded-lg border border-gray-300 p-1 shadow-sm">
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="sharedCpuBilling === 'hourly' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setSharedCpuBilling('hourly')">
              Hourly
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="sharedCpuBilling === 'monthly' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setSharedCpuBilling('monthly')">
              Monthly
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300 relative"
              [ngClass]="sharedCpuBilling === 'yearly' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setSharedCpuBilling('yearly')">
              Yearly
              <span class="absolute -top-2 -right-2 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                {{ sharedCpuOS === 'windows' ? '15% OFF' : '20% OFF' }}
              </span>
            </button>
          </div>
          
          <div class="flex items-center gap-3 bg-white rounded-lg border border-gray-300 p-2 shadow-sm">
            <div class="flex items-center gap-2">
              <label class="text-sm text-gray-600">vCPU</label>
              <input
                type="number"
                min="0"
                step="1"
                [(ngModel)]="filterVcpuExact"
                class="w-20 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
            <div class="flex items-center gap-2">
              <label class="text-sm text-gray-600">RAM (GB)</label>
              <input
                type="number"
                min="0"
                step="4"
                [(ngModel)]="filterRamExactGB"
                class="w-24 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
          </div>
        </div>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gradient-to-r from-gray-50 to-gray-100">
              <tr>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Plan</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">vCPU</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">RAM</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Storage</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="sharedCpuOS === 'windows'">Minimum Billing</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="sharedCpuBilling === 'yearly'">Discount</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="sharedCpuBilling === 'hourly'">Hourly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="sharedCpuBilling === 'monthly'">Monthly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="sharedCpuBilling === 'yearly'">Yearly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let plan of sharedCpuPlans" class="hover:bg-blue-50 transition-colors duration-200">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-semibold text-gray-900">{{ plan.name }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ plan.vcpu }} vCPU</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ plan.ram }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ plan.storage }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-red-600" *ngIf="sharedCpuOS === 'windows'">Minimum Billing: ₹{{ plan.minimumBilling }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-green-600 font-medium" *ngIf="sharedCpuBilling === 'yearly'">{{ plan.discount }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="sharedCpuBilling === 'hourly'">₹{{ plan.hourlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="sharedCpuBilling === 'monthly'">₹{{ plan.monthlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="sharedCpuBilling === 'yearly'">₹{{ plan.yearlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">
                  <button class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
                    Deploy Now
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Dedicated CPU Pricing -->
    <div class="mb-12" *ngIf="isCategoryVisible('compute')">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-6">
        <div>
          <h3 class="text-2xl font-bold text-white mb-2">Dedicated CPU Instances</h3>
          <p class="text-slate-300">
            High-performance dedicated CPU instances for resource-intensive applications.
          </p>
        </div>
        
        <div class="flex flex-col sm:flex-row gap-4">
          <div class="flex bg-white rounded-lg border border-gray-300 p-1 shadow-sm">
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="dedicatedCpuOS === 'linux' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setDedicatedCpuOS('linux')">
              <i class="fab fa-linux mr-2"></i> Linux
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="dedicatedCpuOS === 'windows' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setDedicatedCpuOS('windows')">
              <i class="fab fa-windows mr-2"></i> Windows
            </button>
          </div>
          
          <div class="flex bg-white rounded-lg border border-gray-300 p-1 shadow-sm">
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="dedicatedCpuBilling === 'hourly' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setDedicatedCpuBilling('hourly')">
              Hourly
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="dedicatedCpuBilling === 'monthly' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setDedicatedCpuBilling('monthly')">
              Monthly
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300 relative"
              [ngClass]="dedicatedCpuBilling === 'yearly' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setDedicatedCpuBilling('yearly')">
              Yearly
              <span class="absolute -top-2 -right-2 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                {{ dedicatedCpuOS === 'windows' ? '10% OFF' : '20% OFF' }}
              </span>
            </button>
          </div>
          
          <div class="flex items-center gap-3 bg-white rounded-lg border border-gray-300 p-2 shadow-sm">
            <div class="flex items-center gap-2">
              <label class="text-sm text-gray-600">vCPU</label>
              <input
                type="number"
                min="0"
                step="1"
                [(ngModel)]="filterVcpuExact"
                class="w-20 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
            <div class="flex items-center gap-2">
              <label class="text-sm text-gray-600">RAM (GB)</label>
              <input
                type="number"
                min="0"
                step="4"
                [(ngModel)]="filterRamExactGB"
                class="w-24 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
          </div>
        </div>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gradient-to-r from-gray-50 to-gray-100">
              <tr>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Plan</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">vCPU</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">RAM</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Storage</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="dedicatedCpuOS === 'windows'">Minimum Billing</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="dedicatedCpuBilling === 'yearly'">Discount</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="dedicatedCpuBilling === 'hourly'">Hourly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="dedicatedCpuBilling === 'monthly'">Monthly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="dedicatedCpuBilling === 'yearly'">Yearly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let plan of dedicatedCpuPlans" class="hover:bg-blue-50 transition-colors duration-200">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-semibold text-gray-900">{{ plan.name }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ plan.vcpu }} vCPU</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ plan.ram }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ plan.storage }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-red-600" *ngIf="dedicatedCpuOS === 'windows'">Minimum Billing: ₹{{ plan.minimumBilling }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-green-600 font-medium" *ngIf="dedicatedCpuBilling === 'yearly'">{{ plan.discount }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="dedicatedCpuBilling === 'hourly'">₹{{ plan.hourlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="dedicatedCpuBilling === 'monthly'">₹{{ plan.monthlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="dedicatedCpuBilling === 'yearly'">₹{{ plan.yearlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">
                  <button class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
                    Deploy Now
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- High Memory Pricing -->
    <div class="mb-12" *ngIf="isCategoryVisible('compute')">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-6">
        <div>
          <h3 class="text-2xl font-bold text-white mb-2">High Memory Instances</h3>
          <p class="text-slate-300">
            Optimized instances for memory-intensive applications and databases.
          </p>
        </div>
        
        <div class="flex flex-col sm:flex-row gap-4">
          <div class="flex bg-white rounded-lg border border-gray-300 p-1 shadow-sm">
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="highMemoryOS === 'linux' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setHighMemoryOS('linux')">
              <i class="fab fa-linux mr-2"></i> Linux
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="highMemoryOS === 'windows' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setHighMemoryOS('windows')">
              <i class="fab fa-windows mr-2"></i> Windows
            </button>
          </div>
          
          <div class="flex bg-white rounded-lg border border-gray-300 p-1 shadow-sm">
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="highMemoryBilling === 'hourly' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setHighMemoryBilling('hourly')">
              Hourly
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="highMemoryBilling === 'monthly' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setHighMemoryBilling('monthly')">
              Monthly
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300 relative"
              [ngClass]="highMemoryBilling === 'yearly' ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="setHighMemoryBilling('yearly')">
              Yearly
              <span class="absolute -top-2 -right-2 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                {{ highMemoryOS === 'windows' ? '10% OFF' : '20% OFF' }}
              </span>
            </button>
          </div>
          
          <div class="flex items-center gap-3 bg-white rounded-lg border border-gray-300 p-2 shadow-sm">
            <div class="flex items-center gap-2">
              <label class="text-sm text-gray-600">vCPU</label>
              <input
                type="number"
                min="0"
                step="1"
                [(ngModel)]="filterVcpuExact"
                class="w-20 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
            <div class="flex items-center gap-2">
              <label class="text-sm text-gray-600">RAM (GB)</label>
              <input
                type="number"
                min="0"
                step="4"
                [(ngModel)]="filterRamExactGB"
                class="w-24 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
          </div>
        </div>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gradient-to-r from-gray-50 to-gray-100">
              <tr>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Plan</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">vCPU</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">RAM</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Storage</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="highMemoryOS === 'windows'">Minimum Billing</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="highMemoryBilling === 'yearly'">Discount</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="highMemoryBilling === 'hourly'">Hourly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="highMemoryBilling === 'monthly'">Monthly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="highMemoryBilling === 'yearly'">Yearly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let plan of highMemoryPlans" class="hover:bg-blue-50 transition-colors duration-200">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-semibold text-gray-900">{{ plan.name }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ plan.vcpu }} vCPU</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ plan.ram }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ plan.storage }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-red-600" *ngIf="highMemoryOS === 'windows'">Minimum Billing: ₹{{ plan.minimumBilling }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-green-600 font-medium" *ngIf="highMemoryBilling === 'yearly'">{{ plan.discount }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="highMemoryBilling === 'hourly'">₹{{ plan.hourlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="highMemoryBilling === 'monthly'">₹{{ plan.monthlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="highMemoryBilling === 'yearly'">₹{{ plan.yearlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">
                  <button class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
                    Deploy Now
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Storage Pricing -->
    <div class="mb-12" *ngIf="isCategoryVisible('storage')">
      <div class="mb-8">
        <h3 class="text-2xl font-bold text-white mb-2">Storage Solutions</h3>
        <p class="text-slate-300">
          Flexible and scalable storage solutions for all your data needs.
        </p>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <!-- Block Storage -->
        <div class="bg-white rounded-xl shadow-lg p-6 border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
        <div class="flex items-center mb-4">
          <div class="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center mr-4">
              <i class="bx bx-hdd text-xl text-white"></i>
            </div>
          <h4 class="text-xl font-bold text-white">Block Storage</h4>
          </div>
        <p class="text-slate-300 mb-6">
            High-performance block storage for databases and enterprise applications.
          </p>
          <div class="mb-6">
            <label class="block text-sm font-medium text-gray-700 mb-2">Storage Size (GB)</label>
            <input 
              type="range" 
              min="10" 
              max="10000" 
              [(ngModel)]="blockStorageSize" 
              class="w-full h-2 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg appearance-none cursor-pointer">
            <div class="flex justify-between text-sm text-gray-500 mt-1">
              <span>10 GB</span>
              <span class="font-semibold text-gray-900">{{ blockStorageSize }} GB</span>
              <span>10,000 GB</span>
            </div>
          </div>
          <div class="flex justify-between items-center">
            <div>
              <div class="text-2xl font-bold text-gray-900">₹{{ (blockStorageSize * blockStoragePricePerGB) | number:'1.0-0' }}</div>
              <div class="text-sm text-gray-500">per month</div>
            </div>
            <button class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg">
              Add to Cart
            </button>
          </div>
        </div>
        
        <!-- Object Storage -->
        <div class="bg-white rounded-xl shadow-lg p-6 border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
        <div class="flex items-center mb-4">
          <div class="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-lg flex items-center justify-center mr-4">
              <i class="bx bx-package text-xl text-white"></i>
            </div>
          <h4 class="text-xl font-bold text-white">Object Storage</h4>
          </div>
        <p class="text-slate-300 mb-6">
            Cost-effective object storage for unstructured data and backups.
          </p>
          <div class="space-y-4">
            <div *ngFor="let option of objectStorageOptions" class="flex justify-between items-center py-2 border-b border-gray-100">
              <div>
                <div class="font-medium text-gray-900">{{ option.size }}</div>
                <div class="text-sm text-gray-500">₹{{ option.pricePerGB }}/GB</div>
              </div>
              <div class="text-right">
                <div class="font-bold text-gray-900">₹{{ option.price }}</div>
                <div class="text-sm text-gray-500">per month</div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Archive Storage -->
        <div class="bg-white rounded-xl shadow-lg p-6 border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
        <div class="flex items-center mb-4">
          <div class="w-12 h-12 bg-gradient-to-br from-purple-500 to-violet-600 rounded-lg flex items-center justify-center mr-4">
              <i class="bx bx-archive-in text-xl text-white"></i>
            </div>
          <h4 class="text-xl font-bold text-white">Archive Storage</h4>
          </div>
        <p class="text-slate-300 mb-6">
            Low-cost storage for long-term data archival and backup.
          </p>
          <div class="mb-6">
            <label class="block text-sm font-medium text-gray-700 mb-2">Storage Size (GB)</label>
            <input 
              type="range" 
              min="10" 
              max="10000" 
              [(ngModel)]="archiveStorageSize" 
              class="w-full h-2 bg-gradient-to-r from-purple-500 to-violet-600 rounded-lg appearance-none cursor-pointer">
            <div class="flex justify-between text-sm text-gray-500 mt-1">
              <span>10 GB</span>
              <span class="font-semibold text-gray-900">{{ archiveStorageSize }} GB</span>
              <span>10,000 GB</span>
            </div>
          </div>
          <div class="flex justify-between items-center">
            <div>
              <div class="text-2xl font-bold text-gray-900">₹{{ (archiveStorageSize * archiveStoragePricePerGB) | number:'1.0-0' }}</div>
              <div class="text-sm text-gray-500">per month</div>
            </div>
            <button class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg">
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Database Pricing -->
    <div class="mb-12" *ngIf="isCategoryVisible('databases')">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-6">
        <div>
          <h3 class="text-2xl font-bold text-white mb-2">Managed Databases</h3>
          <p class="text-slate-300">
            Fully managed database services with high availability and automatic backups.
          </p>
        </div>
        
        <div class="flex flex-col sm:flex-row gap-4">
          <!-- Database Engine Selection -->
          <div class="flex bg-white rounded-lg border border-gray-300 p-1 shadow-sm">
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="selectedDatabaseEngine === 'MongoDB' ? 'bg-gradient-to-r from-orange-500 to-amber-600 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="selectedDatabaseEngine = 'MongoDB'; setMongoDbInstanceType('Shared CPU'); setMongoDbBilling('monthly');"
              title="MongoDB">
              <i class="bx bxl-mongodb"></i>
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="selectedDatabaseEngine === 'MySQL' ? 'bg-gradient-to-r from-blue-500 to-cyan-600 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="selectedDatabaseEngine = 'MySQL'; setMySqlInstanceType('Shared CPU'); setMySqlBilling('monthly');"
              title="MySQL">
              <i class="fas fa-database"></i>
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="selectedDatabaseEngine === 'PostgreSQL' ? 'bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="selectedDatabaseEngine = 'PostgreSQL'; setPostgreSqlInstanceType('Shared CPU'); setPostgreSqlBilling('monthly');"
              title="PostgreSQL">
              <i class="bx bxl-postgresql"></i>
            </button>
          </div>
          
          <div class="flex bg-white rounded-lg border border-gray-300 p-1 shadow-sm">
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="
                (selectedDatabaseEngine === 'MongoDB' && mongoDbInstanceType === 'Shared CPU') ||
                (selectedDatabaseEngine === 'MySQL' && mySqlInstanceType === 'Shared CPU') ||
                (selectedDatabaseEngine === 'PostgreSQL' && postgreSqlInstanceType === 'Shared CPU')
                ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="
                selectedDatabaseEngine === 'MongoDB' ? setMongoDbInstanceType('Shared CPU') : 
                selectedDatabaseEngine === 'MySQL' ? setMySqlInstanceType('Shared CPU') : 
                setPostgreSqlInstanceType('Shared CPU')">
              Shared CPU
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="
                (selectedDatabaseEngine === 'MongoDB' && mongoDbInstanceType === 'Dedicated CPU') ||
                (selectedDatabaseEngine === 'MySQL' && mySqlInstanceType === 'Dedicated CPU') ||
                (selectedDatabaseEngine === 'PostgreSQL' && postgreSqlInstanceType === 'Dedicated CPU')
                ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="
                selectedDatabaseEngine === 'MongoDB' ? setMongoDbInstanceType('Dedicated CPU') : 
                selectedDatabaseEngine === 'MySQL' ? setMySqlInstanceType('Dedicated CPU') : 
                setPostgreSqlInstanceType('Dedicated CPU')">
              Dedicated CPU
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="
                (selectedDatabaseEngine === 'MongoDB' && mongoDbInstanceType === 'High Memory') ||
                (selectedDatabaseEngine === 'MySQL' && mySqlInstanceType === 'High Memory') ||
                (selectedDatabaseEngine === 'PostgreSQL' && postgreSqlInstanceType === 'High Memory')
                ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="
                selectedDatabaseEngine === 'MongoDB' ? setMongoDbInstanceType('High Memory') : 
                selectedDatabaseEngine === 'MySQL' ? setMySqlInstanceType('High Memory') : 
                setPostgreSqlInstanceType('High Memory')">
              High Memory
            </button>
          </div>
          
          <div class="flex bg-white rounded-lg border border-gray-300 p-1 shadow-sm">
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300"
              [ngClass]="
                (selectedDatabaseEngine === 'MongoDB' && mongoDbBilling === 'monthly') ||
                (selectedDatabaseEngine === 'MySQL' && mySqlBilling === 'monthly') ||
                (selectedDatabaseEngine === 'PostgreSQL' && postgreSqlBilling === 'monthly')
                ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="
                selectedDatabaseEngine === 'MongoDB' ? setMongoDbBilling('monthly') : 
                selectedDatabaseEngine === 'MySQL' ? setMySqlBilling('monthly') : 
                setPostgreSqlBilling('monthly')">
              Monthly
            </button>
            <button 
              class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-300 relative"
              [ngClass]="
                (selectedDatabaseEngine === 'MongoDB' && mongoDbBilling === 'yearly') ||
                (selectedDatabaseEngine === 'MySQL' && mySqlBilling === 'yearly') ||
                (selectedDatabaseEngine === 'PostgreSQL' && postgreSqlBilling === 'yearly')
                ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-sm' : 'text-gray-700 hover:bg-gray-50'"
              (click)="
                selectedDatabaseEngine === 'MongoDB' ? setMongoDbBilling('yearly') : 
                selectedDatabaseEngine === 'MySQL' ? setMySqlBilling('yearly') : 
                setPostgreSqlBilling('yearly')">
              Yearly
              <span class="absolute -top-2 -right-2 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                20% OFF
              </span>
            </button>
          </div>
        </div>
      </div>
      
      <div class="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gradient-to-r from-gray-50 to-gray-100">
              <tr>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Plan</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Storage</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">RAM</th>

                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="
                  (selectedDatabaseEngine === 'MongoDB' && mongoDbBilling === 'monthly') ||
                  (selectedDatabaseEngine === 'MySQL' && mySqlBilling === 'monthly') ||
                  (selectedDatabaseEngine === 'PostgreSQL' && postgreSqlBilling === 'monthly')">Monthly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider" *ngIf="
                  (selectedDatabaseEngine === 'MongoDB' && mongoDbBilling === 'yearly') ||
                  (selectedDatabaseEngine === 'MySQL' && mySqlBilling === 'yearly') ||
                  (selectedDatabaseEngine === 'PostgreSQL' && postgreSqlBilling === 'yearly')">Yearly</th>
                <th scope="col" class="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let option of 
                selectedDatabaseEngine === 'MongoDB' ? currentMongoDbOptions : 
                selectedDatabaseEngine === 'MySQL' ? currentMySqlOptions : 
                currentPostgreSqlOptions" 
                class="hover:bg-blue-50 transition-colors duration-200">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-semibold text-gray-900">{{ selectedDatabaseEngine }} {{ option.instanceType }} Instance</div>
                  <div class="text-sm text-gray-500">{{ option.node }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ option.storage }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ option.ram }}</td>

                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="
                  (selectedDatabaseEngine === 'MongoDB' && mongoDbBilling === 'monthly') ||
                  (selectedDatabaseEngine === 'MySQL' && mySqlBilling === 'monthly') ||
                  (selectedDatabaseEngine === 'PostgreSQL' && postgreSqlBilling === 'monthly')">₹{{ option.monthlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" *ngIf="
                  (selectedDatabaseEngine === 'MongoDB' && mongoDbBilling === 'yearly') ||
                  (selectedDatabaseEngine === 'MySQL' && mySqlBilling === 'yearly') ||
                  (selectedDatabaseEngine === 'PostgreSQL' && postgreSqlBilling === 'yearly')">₹{{ option.yearlyPrice }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">
                  <button class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
                    Deploy Now
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- FAQ Section -->
    <div class="faq-section-modern">
      <div class="faq-section-header">
        <span class="faq-badge">FAQ</span>
        <h3 class="faq-title">Frequently Asked <span class="faq-highlight">Questions</span></h3>
        <p class="faq-subtitle">Find answers to common questions about our cloud pricing and services</p>
      </div>
      
      <div class="faq-container-modern">
        <div *ngFor="let faq of faqs; let i = index" class="faq-item-modern" [class.faq-active]="expandedFaq === i">
          <div 
            class="faq-question-wrapper"
            (click)="toggleFaq(i)">
            <div class="faq-question-content">
              <h4 class="faq-question-text">{{ faq.question }}</h4>
              <div class="faq-icon-wrapper">
                <i class="bx bx-chevron-down faq-icon" [class.faq-icon-rotated]="expandedFaq === i"></i>
              </div>
            </div>
          </div>
          <div 
            class="faq-answer-wrapper"
            [class.faq-answer-visible]="expandedFaq === i">
            <div class="faq-answer-content">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="faq-footer">
        <p class="faq-footer-text">Still have questions? Our team is here to help!</p>
        <a href="/contact" class="faq-contact-button">
          <i class="bx bx-phone"></i>
          Contact Us
        </a>
      </div>
    </div>
  </div>
</section>
